import { createSlice } from '@reduxjs/toolkit';
import { last } from 'lodash-es';

const initialState = {
    error: null,
    loading: false,
    success: null,
    poExcelFileListRes: null,
    successFailedData: null,
    lastEvaluatedKey: null,
    arrangeOrder: 'asc',
    arrangeKey: '',
}

export const ExcelPoFileReducer = createSlice({
  name: "ExcelPoFileReducer",
  initialState,
  reducers: {
    updateLoading: (state,action) => {
      state.loading = action.payload;
      state.error = null;
    },
    getExcelPoFileSuccess: (state, action) => {
      state.loading = false;
      state.poExcelFileListRes.push(...action.payload);
      state.error = null;
    },
    updateSuccess: (state, action) => {
      state.loading = false;
      state.success = action.payload;
      state.error = null;
    },
    updateLastEvaluatedKey: (state, action) => {
      state.lastEvaluatedKey = action.payload;
    },
    getExcelPoFileFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetExcelPoFileStatus: (state, action) => {
      state.loading = false;
      state.error = null;
      state.poExcelFileListRes = [];
      state.lastEvaluatedKey = null;
      state.success = null;
    },
    updateSuccessFailedData: (state, action) => {
      state.successFailedData = action.payload;
    },
    
  },
});

export const {
  getExcelPoFileSuccess,
  getExcelPoFileFailure,
  updateLoading,
  resetExcelPoFileStatus,
  updateSuccess,
  updateLastEvaluatedKey,
  updateSuccessFailedData
} = ExcelPoFileReducer.actions;

// Selectors
export const getExcelPoFileReducer = (state) => {
  return state.ExcelPoFileReducer;
};

export default ExcelPoFileReducer.reducer;
